//

//const serverSrc='192.168.131.18';
const shareSrc='https://ypapp.cnnb.com.cn/yppage/index.html#/';
const ypImg = 'https://yongpaioss.oss-cn-hangzhou.aliyuncs.com/nf/icon.png'
const domainSrc = 'https://ypapp.cnnb.com.cn/yppage/index.html'
const testShareSrc = "http://172.16.12.211:8001/#"
const devSrc='https://ypapp.cnnb.com.cn/yppage-serves/index.html#/';
export default
{
  //serverSrc,//服务器地址
  shareSrc, //分享地址
  ypImg,
  domainSrc,
  testShareSrc,
  devSrc
}



// WEBPACK FOOTER //
// ./src/components/Global.vue